require("./assets/font/flaticon/flaticon.css");
require("./assets/css/style.less");
require("./assets/css/font_css/iranyekan/iranyekan.css");
require("./assets/css/bttn.min.css");
require("./assets/css/reset.min.css");
require("./assets/css/grid.min.css");



// WEBPACK FOOTER //
// ./src/css.js